import { Box, Divider, Flex } from '@mantine/core';

import { useMediaQuery } from '@mantine/hooks';
import { breakpoints } from 'styles/theme.variables';

interface MappingActionButtonsProps {
  children: React.ReactNode;
}

export default function MappingActionButtons({ children }: MappingActionButtonsProps) {
  const isMobile = useMediaQuery(`(max-width: ${breakpoints.maxMobile})`);
  return (
    <Box
      bottom="0"
      pos="fixed"
      bg="var(--surface-secondary)"
      w={{ sm: 'calc(100% + var(--mantine-spacing-md) * 2)', lg: 'calc(100% - 200px)' }}
      ml={{
        sm: 'calc(var(--mantine-spacing-md) * -1)',
        lg: 'calc(var(--mantine-spacing-xl) * -1)',
      }}
      style={{ zIndex: '1' }}
    >
      <Divider />
      <Flex
        justify="space-between"
        align={isMobile ? 'center' : ''}
        direction={isMobile ? 'column-reverse' : 'row'}
        px={{ sm: 'sm', md: 'xl' }}
        py="sm"
      >
        {children}
      </Flex>
    </Box>
  );
}
